import $ from "jquery";

const MenuAccordion = (el) => {
    const $el = $(el);

    $el.click(function (e) {
        e.preventDefault();

        $el.closest(".menu__item").toggleClass("menu__item--is-open");

        $el.toggleClass("js-state-accordion-open");
        if ($el.hasClass("js-state-accordion-open")) {
            $el.attr("aria-expanded", "true");
        } else {
            $el.attr("aria-expanded", "false");
        }
    });
};

export default MenuAccordion;
